import type { ReduxState } from '@/redux/app/state';

export const navigationStateSelector = (state: ReduxState) => state.navigation;

export const navigationHistorySelector = (state: ReduxState) =>
  navigationStateSelector(state).history;
